import { useSelector } from 'react-redux'
import { ApplicationState } from '@/state/root.models'

import useForm from '@/hooks/form/use-form.hook'
import { FormStatusType } from '@/enums'
import { freeSpinsSchema } from '../components/schema'

import { freeSpinsValidator } from '../components/validator'

const useFreeSpins = () => {
  const { currentBonus, bonusFormMode } = useSelector(
    ({ bonusEngine }: ApplicationState) => bonusEngine,
  )

  const { state, handleOnChange, disable, setFormValues, setDisable } = useForm(
    freeSpinsSchema,
    freeSpinsValidator,
    () => {},
  )

  const setCurrentFreeSpins = () => {
    setFormValues({
      freeSpinQuantity: {
        value: currentBonus.freeSpinQuantity || '',
        error: '',
      },
    })

    bonusFormMode === FormStatusType.CREATE
      ? setDisable(true)
      : setDisable(false)
  }

  return {
    freeSpins: {
      state,
      handleOnChange,
      disable,
      setFormValues,
      setDisable,
    },
    setCurrentFreeSpins,
  }
}

export default useFreeSpins
